import { createTypes } from "../../utils/helpers";

const COMMODITIES_FETCH_COMMODITIES: any = createTypes('COMMODITIES_FETCH_COMMODITIES');
const COMMODITIES_FETCH_COMMODITY_GROUPS: any = createTypes('COMMODITIES_FETCH_COMMODITY_GROUPS');
const COMMODITIES_FETCH_COMMODITIES_CATALOG: any = createTypes('COMMODITIES_FETCH_COMMODITIES_CATALOG');
const COMMODITIES_FETCH_SINGLE_COMMODITY: any = createTypes('COMMODITIES_FETCH_SINGLE_COMMODITY');
const COMMODITIES_FETCH_PROFILES: any = createTypes('COMMODITIES_FETCH_PROFILES');
const COMMODITIES_POST_PROFILE: any = createTypes('COMMODITIES_POST_PROFILE');
const COMMODITY_TRANSLATIONS: any = createTypes('COMMODITY_TRANSLATIONS');
const COMMODITY_TRANSLATIONS_UPDATE: any = createTypes('COMMODITY_TRANSLATIONS_UPDATE',);
const COMMODITIES_CLEAR_SINGLE_COMMODITY = 'COMMODITIES_CLEAR_SINGLE_COMMODITY';
const COMMODITIES_CLEAR_COMMODITIES = 'COMMODITIES_CLEAR_COMMODITIES';
const COMMODITIES_SET_PROFILE_TO_EDIT = 'COMMODITIES_SET_PROFILE_TO_EDIT';
const COMMODITIES_CLEAR_PROFILE_TO_EDIT = 'COMMODITIES_CLEAR_PROFILE_TO_EDIT';
const COMMODITIES_SET_EDITED_PROFILE: any = createTypes('COMMODITIES_SET_EDITED_PROFILE');
const COMMODITY_CATEGORIES_FETCH: any = createTypes('COMMODITY_CATEGORIES_FETCH',);
const COMMODITY_SUBCATEGORIES_FETCH: any = createTypes('COMMODITY_SUBCATEGORIES_FETCH');

export {
    COMMODITIES_FETCH_COMMODITY_GROUPS,
    COMMODITIES_FETCH_COMMODITIES,
    COMMODITIES_FETCH_SINGLE_COMMODITY,
    COMMODITIES_CLEAR_SINGLE_COMMODITY,
    COMMODITIES_CLEAR_COMMODITIES,
    COMMODITIES_FETCH_COMMODITIES_CATALOG,
    COMMODITIES_FETCH_PROFILES,
    COMMODITIES_SET_PROFILE_TO_EDIT,
    COMMODITIES_POST_PROFILE,
    COMMODITIES_SET_EDITED_PROFILE,
    COMMODITIES_CLEAR_PROFILE_TO_EDIT,
    COMMODITY_TRANSLATIONS,
    COMMODITY_TRANSLATIONS_UPDATE,
    COMMODITY_CATEGORIES_FETCH,
    COMMODITY_SUBCATEGORIES_FETCH,
};
